import store from "../../store";
import categories from './categories/categories.vue';
import catalog_view from "./products/catalog_view";
import cities from "./cities/cities";
import restaurants from './restaurants/restaurants'
import organizations from "./organizations/organizations";
import stop_list from "./stop/stop_list";
import employees_list from "./employees/items/employees_list.vue";


window.CATALOG_ATR =  new Vue({
	store,
	el: 'div#catalog_block',

	name : "CATALOG_BLOCK",
	data () {
		return {

		}
	},
	created () {

	},
	components : {
		categories,
		catalog_view,
		cities,
		restaurants,
		organizations,
        stop_list,
        employees_list
	}
});
